import axios from "axios";
import { IP } from "../index.js";
/* 优惠券模块 */
// 查询
export async function selectList() {
  var resp = await axios.post(`${IP}/coupon/selectMoney`, {});
  return resp.data;
}


/* 新增 */
export async function add(data) {
  var resp = await axios.post(`${IP}/coupon/add`, {
    ...data,
  });
  return resp.data;
}

// 修改状态
export async function updateStatus(data) {
  var resp = await axios.post(`${IP}/coupon/update`, {
    ...data,
  });
  return resp.data;
}

// 删除
export async function deleteConpon(data) {
  var resp = await axios.post(`${IP}/coupon/delete`, {
    ...data,
  });
  return resp.data;
}
